var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ReportNav",
    [
      _c(
        "div",
        { staticClass: "section-container" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.pageConfig } },
            [
              _c("el-table-column", { attrs: { prop: "name", label: "名称" } }),
              _c("el-table-column", {
                attrs: { prop: "startFrame", label: "起始帧" },
              }),
              _c("el-table-column", {
                attrs: { prop: "endFrame", label: "结束帧" },
              }),
              _c("el-table-column", {
                attrs: { prop: "fpsAverage", label: "区间平均帧率" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.showDetail(row)
                              },
                            },
                          },
                          [_vm._v("查看详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "区间详情(" +
              _vm.dialogData.startFrame +
              "-" +
              _vm.dialogData.endFrame +
              ")",
            visible: _vm.dialogShow,
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogShow = $event
            },
            close: _vm.hiddenDetail,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-container tablist" },
            [
              _c("p", { staticClass: "top-tips" }, [
                _vm._v(
                  "共包含 " +
                    _vm._s(
                      _vm.dialogData.endFrame - _vm.dialogData.startFrame + 1
                    ) +
                    " 帧 区间评分为 "
                ),
                _c("span", [_vm._v(_vm._s(_vm.dialogData.score))]),
                _vm._v(
                  " ( 从 " +
                    _vm._s(_vm.dialogData.startFrame) +
                    " - " +
                    _vm._s(_vm.dialogData.endFrame) +
                    " 帧)"
                ),
              ]),
              _c("div", { staticClass: "chart-title-wrapper" }, [
                _c("i", { staticClass: "chart-title-tag" }),
                _c("div", { staticClass: "chart-title" }, [
                  _c("span", [_vm._v("性能概况")]),
                ]),
              ]),
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                _vm._l(_vm.dialogData.summary, function (item) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: item.name,
                      attrs: { label: item.title, name: item.name },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "dialog-data-list" },
                        _vm._l(item.summary, function (one, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "dialog-data-box",
                              class: {
                                danger:
                                  Boolean(one.advice) &&
                                  (one.advice.symbol == "lt"
                                    ? one.advice.data[_vm.reportDevice][
                                        one.advice.data.length - 1
                                      ] > one.value
                                    : one.advice.data[_vm.reportDevice][
                                        one.advice.data.length - 1
                                      ] < one.value),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "dialog-title" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "title-text ellipse" },
                                    [_vm._v(_vm._s(one.title))]
                                  ),
                                  one.help
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "right",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "rule-tip-content",
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "rule-tip-suggestion",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.help[one.help].title
                                                    )
                                                  ),
                                                ]
                                              ),
                                              Boolean(one.advice)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "rule-tip-recommend",
                                                    },
                                                    [
                                                      _vm._v("建议值"),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            one.advice
                                                              .symbol === "lt"
                                                              ? ">"
                                                              : "<"
                                                          ) +
                                                            _vm._s(
                                                              one.advice.data[
                                                                _vm.reportDevice
                                                              ][
                                                                one.advice.data
                                                                  .length - 1
                                                              ]
                                                            ) +
                                                            _vm._s(
                                                              _vm.help[one.help]
                                                                .unit
                                                            )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._l(
                                                _vm.help[one.help].desc.split(
                                                  "\r\n"
                                                ),
                                                function (tip, tipsIndex) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        one.help +
                                                        "-" +
                                                        tipsIndex,
                                                      staticClass: "rule-tip-p",
                                                    },
                                                    [_vm._v(_vm._s(tip))]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-question",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "dialog-value" }, [
                                _vm._v(_vm._s(one.value)),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }